var _style, _path, _path2, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriglycerideLevels({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A384F;}\n\t.st1{fill:#E6393D;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#F8EEE1;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106,183.6c42.8,0,77.6-34.4,77.6-76.9c0-42.4-34.7-76.9-77.6-76.9s-77.6,34.4-77.6,76.9 C28.4,149.2,63.2,183.6,106,183.6"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.4,71.4c-1.9-0.7-4-1.1-6.1-1.2c-0.7-0.1-1.1,0-1.1,0c-12.5,0.1-22.5,11.3-22.3,25 C105.7,81.5,95.5,70.5,83,70.6c-12.5,0.1-22.5,11.3-22.3,25c-1.4,31,45.8,58.5,45.8,58.5s9.4-6.2,19.6-15.5 c23.8-21.6,25.5-36.8,25.3-42C152,79.7,142.5,73.6,135.4,71.4z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M135.4,71.4c-1.9-0.7-4-1.1-6.1-1.2c-0.7-0.1-1.1,0-1.1,0c-12.5,0.1-22.5,11.3-22.3,25 C105.7,81.5,95.5,70.5,83,70.6c-12.5,0.1-22.5,11.3-22.3,25c-1.4,31,45.8,58.5,45.8,58.5s9.4-6.2,19.6-15.5 c23.8-21.6,25.5-36.8,25.3-42C152,79.7,142.5,73.6,135.4,71.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 57.2,
    y: 111.7,
    className: "st2",
    width: 105.9,
    height: 50.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriglycerideLevels);
export default __webpack_public_path__ + "static/media/Triglyceride_Levels.9ae711edd786bfe39cbb36d3d5db68b2.svg";
export { ForwardRef as ReactComponent };